const SlickScrollbar = (function () {
  const root = document.querySelector(':root');

  const scrollbarDefaultVariables = {
    "--main-scrollbar-color": "#CBCBCB",
    "--muted-scrollbar-color": "#F8F8F8",
    "--parent-scrollbar-padding": "0px",
    "--parent-scrollbar-offset-left": "0px",
    "--parent-scrollbar-offset-right": "0px",
    "--scrollbar-container-width": "100%",
    "--scrollbar-container-height": "100%"
  }

  Object.entries(scrollbarDefaultVariables).forEach(([key, value]) => root.style.setProperty(key, value));

  const style = document.createElement("style");
  (document.head || document.getElementsByTagName('head')[0]).appendChild(style)
  const css = `.slick-scrollbar__container {
    --border-radius: 100rem;
    cursor: pointer;
    position: relative;
    left: calc(0px - (var(--parent-scrollbar-padding) / 2) + var(--parent-scrollbar-offset-left));
    opacity: 0;
    transition: .3s opacity ease;
  }

  .slick-scrollbar__container:not([data-vertical]) {
    --scrollbar-container-width: 100%;
    --scrollbar-container-height: 5px;
    width: calc(var(--scrollbar-container-width) + var(--parent-scrollbar-padding) - var(--parent-scrollbar-offset-left) - var(--parent-scrollbar-offset-right));
    height: var(--scrollbar-container-height);
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  
  .slick-scrollbar__container[data-vertical] {
    --scrollbar-container-height: 100%;
    --scrollbar-container-width: 5px;
    height: calc(var(--scrollbar-container-height) + var(--parent-scrollbar-padding) - var(--parent-scrollbar-offset-left) - var(--parent-scrollbar-offset-right));
    width: var(--scrollbar-container-width);
  }
  
  .slick-scrollbar__container[data-hide] {
    opacity: 0;
    visibility: hidden;
    margin-top: 0;
    margin-bottom: 0;
  }

  .slick-scrollbar__container::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--muted-scrollbar-color);
    border-radius: var(--border-radius);
    top: 0;
  }

  .slick-scrollbar__container[data-vertical] .slick-scrollbar__thumb {
    height: calc(var(--scrollbar-container-height) / var(--totalSlides));
    min-height: 10%;
    width: 100%;
    left: 50% !important;
    top: 0;
    transform: translate(-50%, 0);
  }

  .slick-scrollbar__container:not([data-vertical]) .slick-scrollbar__thumb {
    left: 0;
    top: 50% !important;
    transform: translate(0, -50%);
    width: calc(var(--scrollbar-container-width) / var(--totalSlides));
    min-width: 10%;
    height: 100%;
  }

  .slick-scrollbar__container .slick-scrollbar__thumb {
    position: relative;
    background: var(--main-scrollbar-color);
    border-radius: var(--border-radius);
  }

  .slick-scrollbar__container[data-vertical] .slick-scrollbar__breakpoints {
    left: 0;
    top: calc(var(--scrollbar-container-height) / (var(--totalSlides) / var(--position)));
  }

  .slick-scrollbar__container:not([data-vertical]) .slick-scrollbar__breakpoints {
    left: calc(var(--scrollbar-container-width) / (var(--totalSlides) / var(--position)));
    top: 0;
  }
  
  .slick-scrollbar__breakpoints {
    display: flex;
    height: 100%;
    width: 0;
    position: absolute;
  }
  `

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  const attach = (navFor = "", uniqId = "") => {

    const CONFIG = {
      navFor,
      breakpointSelector: `#slickScrollbarBreakpoints-${uniqId}`,
      scrollbarSelector: `#slickScrollbarThumb-${uniqId}`,
      scrollbarContainerSelector: `#slickScrollbarContainer-${uniqId}`
    }

    const debounce = (cb, delay = 250) => {
      let timeout

      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          cb(...args)
        }, delay)
      }
    }

    const getClosest = (breakpoints, left, slick) => {
      let closestDiff = Infinity;
      let closestIndex = -1

      const _ = breakpoints.get().reduce((_, elem, index) => {
        let bp = 0;
        if (slick.currentSettings.verticalScrollbar) bp = $(elem).position().top;
        else bp = $(elem).position().left;
        const abs = Math.abs(bp - left)
        if (abs < closestDiff) {
          closestDiff = abs;
          diff = bp;
          closestIndex = index;
        }
        return diff;
      }, closestDiff)
      return closestIndex;
    }

    const hide = ({ scrollbarContainer }) => scrollbarContainer.attr("data-hide", "")
    const show = ({ scrollbarContainer }) => scrollbarContainer.removeAttr("data-hide");

    const shouldHide = ({ slick, scrollbarContainer }) => {
      if (slick.options.slidesToShow >= slick.slideCount) {
        hide({ scrollbarContainer })
        return true;
      } else {
        show({ scrollbarContainer })
        return false;
      }
    }


    const calcScrollbar = ({ scrollbar, breakpoints, slick, scrollbarContainer }) => (_, __, current, next) => {
      if (next === current) return;
      const { options: { slidesToScroll, swipeToSlide } } = slick;
      const nextIndex = swipeToSlide ? next : next / slidesToScroll;
      const nextBreakpoint = $(breakpoints.get(nextIndex))
      // if (!nextBreakpoint) return;
      if (slick.currentSettings.verticalScrollbar) {
        const top = Math.max(0, Math.min(scrollbarContainer.height() - scrollbar.height(), nextBreakpoint.position().top))
        scrollbar.animate({ top }, { duration: 255 });
      } else {
        const left = Math.max(0, Math.min(scrollbarContainer.width() - scrollbar.width(), nextBreakpoint.position().left))
        scrollbar.animate({ left }, { duration: 255 });
      }
    }


    const calcSlickSlider = ({
      slick,
      scrollbarContainer,
      breakpoints
    }) => (_, ui) => {
      shouldHide({ slick, scrollbarContainer });
      const { options: { slidesToScroll } } = slick;
      let nextIndex = getClosest(breakpoints, slick.currentSettings.verticalScrollbar ? ui.position.top : ui.position.left, slick);
      nextIndex = nextIndex * slidesToScroll;
      slick.goTo(nextIndex);
    }

    const deleteBreakpoints = ({ scrollbarContainer }) => scrollbarContainer.children().first().nextAll().remove();

    const createBreakpoints = ({ slick, scrollbarContainer }) => {
      const breakpoint = $(CONFIG.breakpointSelector).first().clone();
      let { slideCount, options: { infinite: isInfinite, swipeToSlide, slidesToShow, slidesToScroll } } = slick;
      deleteBreakpoints({ scrollbarContainer });

      if (swipeToSlide) slidesToScroll = 1;
      const totalSlides = isInfinite ? Math.round(slideCount / slidesToScroll) : Math.ceil((slideCount - Math.floor(slidesToShow)) / slidesToScroll) + 1;
      scrollbarContainer.css("--totalSlides", totalSlides)
      if (slick.currentSettings.verticalScrollbar) scrollbarContainer.attr("data-vertical", "")
      else scrollbarContainer.removeAttr("data-vertical")

      for (let i = 0; i < totalSlides; i++) {
        scrollbarContainer.append(breakpoint.clone().css("--position", i))
      }
      return scrollbarContainer.children().first().nextAll()
    }

    const calcScrollOnClick = ({
      slick,
      scrollbar,
      breakpoints,
      scrollbarContainer
    }) => function (event) {
      if (slick.currentSettings.verticalScrollbar) {
        const containerHeight = scrollbarContainer.height(),
          scrollbarHeight = scrollbar.height(),
          max = containerHeight - scrollbarHeight,
          min = 0,
          calculatedTop = event.offsetY - (scrollbarHeight / 2),
          top = Math.max(min, Math.min(max, calculatedTop));
        scrollbar.animate({ top }, { duration: 255 })
        calcSlickSlider({ slick, scrollbar, breakpoints, scrollbarContainer })(event, { position: { top } });
      } else {
        const containerWidth = scrollbarContainer.width(),
          scrollbarWidth = scrollbar.width(),
          max = containerWidth - scrollbarWidth,
          min = 0,
          calculatedLeft = event.offsetX - (scrollbarWidth / 2),
          left = Math.max(min, Math.min(max, calculatedLeft));
        scrollbar.animate({ left }, { duration: 255 })
        calcSlickSlider({ slick, scrollbar, breakpoints, scrollbarContainer })(event, { position: { left } });
      }
    }

    const setup = ({ slick, scrollbarContainer, breakpoint = window.innerWidth }) => {
      slick.currentSettings = {};
      if (slick.options && slick.options.responsive && slick.options.responsive.length) {
        const { settings } = slick.options.responsive.reduce((acc, resp) => {
          const cur = Math.abs(acc.breakpoint - breakpoint),
            possible = Math.abs(resp.breakpoint - breakpoint);

          if (possible <= cur) return resp;
          return acc;
        }, slick.options.responsive[0])
        slick.currentSettings = settings;
      }
      scrollbarContainer.css({ opacity: 1 })
    }

    let onClickEvent, draggableElem, scrollEvent;

    $(CONFIG.navFor).on('init refresh breakpoint reInit', function (_, slick, breakpoint = window.innerWidth) {
      const slickSlider = $(CONFIG.navFor)
      const scrollbar = $(CONFIG.scrollbarSelector)
      const scrollbarContainer = $(CONFIG.scrollbarContainerSelector);
      setup({ slick, scrollbarContainer, breakpoint: breakpoint || window.innerWidth });
      if (shouldHide({ slick, scrollbarContainer })) return;
      if (slick.currentSettings === "unslick") {
        hide({ scrollbarContainer })
        return;
      }

      const breakpoints = createBreakpoints({ slick, scrollbarContainer })
      const scroll = calcScrollbar({ slick, scrollbar, scrollbarContainer, breakpoints })
      const slide = debounce(calcSlickSlider({ slick, scrollbarContainer, breakpoints }), 100);
      const click = calcScrollOnClick({ slick, scrollbar, breakpoints, scrollbarContainer })

      scroll(null, null, -1, slick.currentSlide)

      // lifecycle
      shouldHide({ slick, scrollbarContainer });

      // destroy events
      if (draggableElem) draggableElem.draggable("destroy");
      if (onClickEvent) scrollbarContainer.off('click', onClickEvent);
      if (scrollEvent) slickSlider.off('beforeChange', scrollEvent);

      // create events
      scrollbar.hover(() => slick.pause(), () => {
        if (!slick.options.autoplay) return;
        slick.play();
      })

      if (slick.currentSettings.verticalScrollbar) {
        draggableElem = scrollbar.draggable({
          axis: "y",
          containment: CONFIG.scrollbarContainerSelector,
          stop: slide,
        })
      } else {
        draggableElem = scrollbar.draggable({
          axis: "x",
          containment: CONFIG.scrollbarContainerSelector,
          stop: slide,
        })
      }

      slickSlider.on('beforeChange', scroll)
      scrollbarContainer.on('click', click);
      onClickEvent = click;
      scrollEvent = scroll;
    })
  }

  return { attach }
})()